// extracted by mini-css-extract-plugin
export default {"cls1":"YOqX8PYvH8PGdxxCr9VC","cls2":"tIczXmbA2NI4AhfbHHfV YOqX8PYvH8PGdxxCr9VC"};